import React                   from 'react'
import { connect }             from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
// import { bindActionCreators }  from 'redux'
import i18n from '../../../i18n'
import Formsy from 'formsy-react'
import Input from '../../forms/services/Input'
import Radio from '../../forms/services/Radio'
import Table from '../../forms/services/Table'
import NormalInput from '../../forms/Input'
import CheckBox from '../../forms/services/CheckBox'
import "react-datepicker/dist/react-datepicker.css"
import DatePicker from '../../forms/DatePicker'
import {mapDispatchToProps} from "../../mapDispatchToProps"
import ReactHtmlParser from 'html-react-parser'
import Loading from '../../common/Loading'
import withBaseComponent from '../../withBaseComponent'

class NewBank extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);
    this.state = {
      hasSpecifyDate: false,
      isFetching: true
    }
  }

  specifyDate(e) {
    this.setState({hasSpecifyDate: "true" === e.target.value })
  }

  render_field(item) {
    let fields = null

    var opts = {
      // name: item.type,
      item: item,
      form: this.refs.form,
      className: "form-group col-md-12"
    }

    if (!item.is_optional && item.input_type !== "checkbox")
      opts = Object.assign({}, opts, { required: true })

    switch(item.input_type) {
      case "table":
        fields = <Table name={`credentials[${item.type}]`} {...opts} />
        break;
      case "checkbox":
        fields = <CheckBox name={`credentials[${item.type}]`} type="checkbox" {...opts} />
        break
      case "radio":
        opts['defaultValue'] = item.is_optional ? "" : {radio: item.format.radio[0]}
        fields = <Radio name={`credentials[${item.type}]`} {...opts} />
        break
      default:
        opts['type'] = item.input_type === "password" ? "password" : "text"
        fields = <Input name={`credentials[${item.type}]`} {...opts} />
    }

    return fields
  }

  render_forms() {
    if (!this.props.currentService)
      return null

    return (
      <div className="w100">
        {this.props.currentService && this.props.currentService.forms.map(item => {
            if (!item.is_displayable)
              return null
            return (<div key={item.id} className="form-row">
              {this.render_field(item)}
            </div>
        )})}
        <NormalInput type="hidden" name="service_id" value={this.props.service && this.props.service.id} />
        <NormalInput type="hidden" name="display_name" value={this.props.service && this.props.service.name} />
        <div className="form-row">
          <label className=" ">{i18n.t('bank.get_data_date')}</label>
          <div className="form-group checkbox-form">
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="is_specify_date" id="no_date" value={false} defaultChecked onChange={(e) => this.specifyDate(e)} />
              <label className="form-check-label" htmlFor="no_date">
                {i18n.t('bank.no_date')}
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="is_specify_date" id="specify_date" value={true} onChange={(e) => this.specifyDate(e)}/>
              <label className="form-check-label" htmlFor="specify_date">
                {i18n.t('bank.after_specify_date')}
              </label>
            </div>
          </div>
        </div>
        {this.state.hasSpecifyDate && <div className="form-row">
          <label className="col-sm-12">{i18n.t('bank.md_newbank.body.select_date')}</label>
          <div className="col-sm-12 form-group mfc-box-calendar">
            <DatePicker
              name="aggregation_start_date"
              required validations="minLength:10"
              validationError="This value must is date"
              startDate={this.state.startDate}
              dateFormat={"yyyy/MM/dd"} />
          </div>
        </div>}
      </div>
    )
  }

  filter(model) {
    if(model && !model['aggregation_start_date']) {
      model['aggregation_start_date'] = null
    }

    return model
  }

  onSubmit(model) {
    if (this.hasError())
      return

    model["credentials"] = Object.values(model["credentials"])
    model = this.filter(model)
    this.props.accountActions.accountCreate(model).then(() => {
      this.props.toggle()
    }).then(() => {
      // Refresh bank after add a new account
      const lastAccount = this.props.accountList[this.props.accountList.length - 1]
      this.props.accountActions.accountShow(lastAccount.id).then(() => {
        this.props.onCreated()
      })
    })
  }

  render() {
    const requires_provider_auth = this.props.currentService && this.props.currentService.requires_provider_auth

    if (requires_provider_auth)
      return null

    const title = (this.props.service && this.props.service.name) || i18n.t('bank.md_newbank.header.title')
    const {currentService} = this.props
    return (
      <Modal isOpen={this.props.isOpen} className={`mfc-modal-normal bank-modal`} centered={true}>
        <Formsy onChange={this.showErrors} ref="form" className="form" onInvalidSubmit={this.showErrors} onSubmit={(model) => this.onSubmit(model)} onValid={this.enableButton} onInvalid={this.disableButton}>
          <ModalHeader toggle={this.props.toggle}>{title}</ModalHeader>
          {!this.props.currentService?
            <ModalBody>
              <Loading className="fa-7x" />
            </ModalBody> :
            <ModalBody>
            <div className="row no-gutters mfc-new-bank-desc">
              <div className="col-sm-12 info-service ">
                <p>金融機関登録前のご注意事項</p>
                <p className="small-desc">
                  {this.props.currentService && typeof this.props.currentService.description === 'string' &&
                    ReactHtmlParser(this.props.currentService.description)}
                </p>
                {currentService && currentService.login_url && <a target="_blank" href={currentService.login_url} rel="noopener noreferrer"><i
                  className="fas fa-external-link-alt"></i> {`${currentService.name}のサイトでログインに用いる情報を確認する`}</a>}
              </div>

              {this.render_forms()}
            </div>
          </ModalBody>}
          {this.props.currentService && <ModalFooter>
            <Button onClick={this.props.toggle} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
            <button className="btn mfc-btn-blue medium" type="submit">
              {i18n.t('common.save')}
            </button>
          </ModalFooter>}
        </Formsy>
      </Modal>
    );
  }
}


function mapStateToProps(state) {
  return {
    currentService: state.service.get('currentService'),
    accountList: state.user.get('accounts')
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewBank)
